<script>
  import { layoutMethods, customerListComputed} from "@/state/helpers";

  /**
   * Profile Soc Med component
   */
  export default {
    page: {
      title: "Profile Soc Med"
    },
    components: {
    },
    computed: {
      ...customerListComputed
    },
    data() {
      return {
        title: "Profile Soc Med"
      };
    },
    methods: {
      ...layoutMethods,
      isEmpty (value) {
          return (
            // null or undefined
            (typeof value == "undefined") || 
            (value == undefined) ||
            (value == null) ||
            (value === "") ||
            // has length and it's zero
            // (value.hasOwnProperty('length') && value.length === 0) ||
            (Object.prototype.hasOwnProperty.call(value, length) && value.length === 0) ||
            // is an Object and has no keys
            (value.constructor === Object && Object.keys(value).length === 0)
          )
      }
    },
    async mounted(){
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="card-body">
        <div>
          <ul class="list-unstyled mb-0 text-muted">
            <li>
              <div>
                <div>
                  <i class="mdi mdi-facebook font-size-16 text-blue me-1"></i>
                  Facebook
                </div>
                <div v-if="!isEmpty(socialMedias.Facebook)">
                  <a :href="socialMedias.Facebook" target="_blank"><small>{{socialMedias.Facebook}}</small></a>
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </li>
            <li>
              <div>
                <div>
                  <i
                    class="mdi mdi-twitter font-size-16 text-info me-1"
                  ></i>
                  Twitter
                </div>
                <div v-if="!isEmpty(socialMedias.Twitter)">
                  <a :href="socialMedias.Twitter" target="_blank"><small>{{socialMedias.Twitter}}</small></a>
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </li>
            <li>
              <div>
                <div>
                  <i
                    class="mdi mdi-instagram font-size-16 text-danger me-1"
                  ></i>
                  Instagram
                </div>
                <div v-if="!isEmpty(socialMedias.Instagram)">
                  <a :href="socialMedias.Instagram" target="_blank"><small>{{socialMedias.Instagram}}</small></a>
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </li>
            <li>
              <div>
                <div>
                  <i
                    class="mdi mdi-youtube font-size-16 text-danger me-1"
                  ></i>
                  Youtube
                </div>
                <div v-if="!isEmpty(socialMedias.Youtube)">
                  <a :href="socialMedias.Youtube" target="_blank"><small>{{socialMedias.Youtube}}</small></a>
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> <!-- end of outer div-->
</template>

<style>
</style>